import { StyleSheet } from 'aphrodite';
import { antiFlashWhite, inputBorderColor } from '../../styles/colors';
import { shadowSm } from '../../styles/shadows';

export const s = StyleSheet.create({
	base: {
		display: 'flex',
		width: 'fit-content',
		alignItems: 'stretch',
		// Focus-visible handling - bring focused element to front
		':has(*) > *:focus-visible': {
			zIndex: 10,
			position: 'relative',
		},
		// Select trigger width handling
		':has(*) > [data-slot="select-trigger"]': {
			width: 'fit-content',
		},
		// Input should be flex-1
		':has(*) > input': {
			flex: 1,
		},
		// Handle nested button groups with gap
		':has(> [data-slot="button-group"])': {
			gap: 8,
		},
		// Edge case: hidden select as last child
		':has(select[aria-hidden="true"]:last-child) > [data-slot="select-trigger"]:last-of-type': {
			borderTopRightRadius: 8,
			borderBottomRightRadius: 8,
		},
	},
	horizontal: {
		// Remove left border-radius and border for all children except first
		':has(*) > *:not(:first-child)': {
			borderTopLeftRadius: 0,
			borderBottomLeftRadius: 0,
			borderLeft: 0,
		},
		// Remove the 1px border added on Button hover as well
		':has(*) > *:not(:first-child):hover': {
			borderLeft: 0,
		},
		':has(*) > *:not(:nth-last-child(1 of :not([aria-hidden],span[data-base-ui-inert],span[data-base-ui-focus-guard],span[aria-owns])))':
			{
				borderTopRightRadius: 0,
				borderBottomRightRadius: 0,
			},
	},
	vertical: {
		flexDirection: 'column',
		// Remove top border-radius and border for all children except first
		':has(*) > *:not(:first-child)': {
			borderTopLeftRadius: 0,
			borderTopRightRadius: 0,
			borderTop: 0,
		},
		// Remove bottom border-radius for all children except last
		':has(*) > *:not(:last-child)': {
			borderBottomLeftRadius: 0,
			borderBottomRightRadius: 0,
		},
	},
	text: {
		background: antiFlashWhite,
		display: 'flex',
		alignItems: 'center',
		gap: 8,
		borderRadius: 8,
		border: `1px solid ${inputBorderColor}`,
		paddingLeft: 16,
		paddingRight: 16,
		fontSize: 14,
		fontWeight: 400,
		boxShadow: shadowSm,
		// SVG handling
		':has(*) svg': {
			pointerEvents: 'none',
			width: 16,
			height: 16,
		},
	},
	separator: {
		background: inputBorderColor,
		position: 'relative',
		margin: 0,
		alignSelf: 'stretch',
		':is([data-orientation="vertical"])': {
			height: 'auto',
		},
	},
});
